import { Box, Divider, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import RedirectButton from '../../../common/component/parts/RedirectButton';
import RedirectMenu from '../../../common/component/parts/RedirectMenu';
import { content, main, pageTitle, width } from '../../../common/const/componentSize';
import { header, modelName } from '../../../common/const/commonConst';
import { DialogType } from '../../../common/type/DialogType';
import { useStateOffsegMenu } from '../../../common/component/hooks/useStateOffsegMenu';
import { useStateG500LiteMenu } from '../../../common/component/hooks/useStateG500LiteMenu';

import { useStateEventVideo } from '../hooks/useStateEventVideo';
import { EventVideoSearch } from '../parts/EventVideoSearch';
import { EventVideoTable } from '../parts/EventVideoTable';
import { g500LiteMenuItemList, offsegMenuItemList, pageName, resultNumLable } from '../../const/eventVideoPageConst';
import { resultNumBox, searchBox, resultNum, tableBox, searchBoxAndresultNumBox, search } from '../../const/eventVideoPageSize';

import theme from '../../../theme';

type PropsType = {
	setIsAsyncProcess: React.Dispatch<React.SetStateAction<boolean>>;
	setDialog: React.Dispatch<React.SetStateAction<DialogType>>;
};

/**
 * イベント映像一覧画面
 */
export const EventVideoPage = (props: PropsType): JSX.Element => {
	const { setIsAsyncProcess, setDialog } = props;

	const { anchorElOffsegMenu, openOffsegMenu, handleOpenOffsegMenu, handleCloseOffsegMenu } = useStateOffsegMenu(); // Offseg遷移メニューの状態管理用カスタムフック
	const { anchorElG500LiteMenu, openG500LiteMenu, handleOpenG500LiteMenu, handleCloseG500LiteMenu } = useStateG500LiteMenu(); // G500Lite遷移メニューの状態管理用カスタムフック

	const { eventVideoInfoList, setEventVideoInfoList } = useStateEventVideo(); // イベント映像一覧の状態管理用カスタムフック

	const resultNumList = [
		{
			label: resultNumLable.offseg,
			num: eventVideoInfoList.filter((item) => item.model === modelName.offseg).length,
		},
		{
			label: resultNumLable.g500Lite,
			num: eventVideoInfoList.filter((item) => item.model === modelName.g500Lite).length,
		},
		{
			label: resultNumLable.sum,
			num: eventVideoInfoList.length,
		},
	];

	return (
		<Box
			id="eventVideoPage"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'flex-start',
				position: 'absolute',
				top: pageTitle.top,
				height: main.height,
				width: width,
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: pageTitle.height, width: width }}>
				{/* ページタイトル */}
				<Box sx={{ minWidth: searchBoxAndresultNumBox.width }}>
					<Typography id="pageTitle" role="lable" aria-label={pageName} sx={{ fontSize: 25, fontWeight: 'bold', color: theme.palette.common.black }}>
						&nbsp;&nbsp;{pageName}
					</Typography>
				</Box>
				{/* 遷移ボタン */}
				<RedirectButton handleOpenOffsegMenu={handleOpenOffsegMenu} handleOpenG500LiteMenu={handleOpenG500LiteMenu} />
				<Typography
					role="lable"
					aria-label={header.maxSearchNumMessage}
					sx={{ fontSize: 14, color: theme.palette.common.black, marginRight: 3 }}
					noWrap
				>
					{header.maxSearchNumMessage}
				</Typography>
			</Box>
			{/* 遷移メニュー */}
			<RedirectMenu
				anchorElOffsegMenu={anchorElOffsegMenu}
				anchorElG500LiteMenu={anchorElG500LiteMenu}
				openOffsegMenu={openOffsegMenu}
				openG500LiteMenu={openG500LiteMenu}
				handleCloseOffsegMenu={handleCloseOffsegMenu}
				handleCloseG500LiteMenu={handleCloseG500LiteMenu}
				offsegMenuItemList={offsegMenuItemList}
				g500LiteMenuItemList={g500LiteMenuItemList}
			/>
			{/* コンテンツ */}
			<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', height: content.height }}>
				{/* 検索表示&実績件数表示 */}
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						height: searchBoxAndresultNumBox.height,
						width: searchBoxAndresultNumBox.width,
					}}
				>
					{/* 検索表示 */}
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'flex-start',
							position: 'absolute',
							top: searchBox.top,
							left: searchBox.left,
							height: searchBox.height,
							width: searchBox.width,
							background: theme.palette.primary.light,
							borderRadius: searchBox.borderRadius,
						}}
					>
						<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: search.titleHeight, marginLeft: search.titleMarginLeft }}>
							<SearchIcon sx={{ fontSize: 27, color: theme.palette.common.black }} />
							<Typography role="lable" aria-label={header.search} sx={{ fontSize: 20, color: theme.palette.common.black }}>
								{header.search}
							</Typography>
						</Box>
						<Divider flexItem />
						<Box>
							<EventVideoSearch setEventVideoInfoList={setEventVideoInfoList} setIsAsyncProcess={setIsAsyncProcess} setDialog={setDialog} />
						</Box>
					</Box>
					{/* 実績件数表示 */}
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'flex-start',
							position: 'absolute',
							top: resultNumBox.top,
							left: resultNumBox.left,
							height: resultNumBox.height,
							width: resultNumBox.width,
						}}
					>
						<Typography role="lable" aria-label={resultNumLable.title} sx={{ fontSize: 25, color: theme.palette.common.black }}>
							{resultNumLable.title}
						</Typography>
						{resultNumList.map((item) => (
							<Box
								key={item.label}
								sx={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									width: resultNum.width,
									marginLeft: resultNum.marginLeft,
									marginTop: resultNum.marginTop,
								}}
							>
								<Box sx={{ width: resultNum.lableWidth }}>
									<Typography role="lable" aria-label={item.label} sx={{ fontSize: 25, color: theme.palette.common.black }}>
										{item.label}
									</Typography>
								</Box>
								<Typography
									id={`${item.label}dataNum`}
									role="lable"
									aria-label={`${item.label}${item.num}`}
									sx={{ fontSize: 25, color: theme.palette.primary.dark, fontWeight: 'bold' }}
								>
									{item.num}
								</Typography>
								<Typography role="lable" aria-label={`${item.label}${resultNumLable.unit}`} sx={{ fontSize: 25, color: theme.palette.common.black }}>
									{resultNumLable.unit}
								</Typography>
							</Box>
						))}
					</Box>
				</Box>
				{/* テーブル表示 */}
				<Box sx={{ height: tableBox.height, width: tableBox.width }} display="flex">
					<EventVideoTable eventVideoInfoList={eventVideoInfoList} />
				</Box>
			</Box>
		</Box>
	);
};
